import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, forkJoin, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DiseasesService {
  constructor(private http: HttpClient) {}

  /***********************login************************** */

  leftPanelHistory(individualId, queryParams?) {
    return this.http.get('/cphm/php/individual/' + individualId + '/leftPanel'+ (queryParams ? '?addnlFields='+queryParams: ''));
  }

  getInvestigationData(individualId) {
    return this.http.get('/cphm/php/individual/' + individualId + '/leftPanel/investigation');
  }
  getVitalHistoryData(individualId) {
    return this.http.get('/cphm/php/individual/' + individualId + '/initialAssessment/vitalsHistory');
  }

  getmedicinesList = function (data) {
    return this.http.get('/cphm/drug/management/medicine/' + data + '/search');
  };

  savePatientHistoryDetails(data, individualId) {
    return this.http.post('/cphm/php/individual/' + individualId + '/initialAssessment', data);
  }

  getPatientHistoryDetails(individualId) {
    return this.http.get('/cphm/php/individual/' + individualId + '/initialAssessment');
  }

  getPatientHistoryDetailsForEachTab(individualId, type) {
    return this.http.get('/cphm/php/individual/' + individualId + '/initialAssessment/' + type);
  }

  savePatientHistoryDetailsForEachTab(individualId, type, data) {
    return this.http.post('/cphm/php/individual/' + individualId + '/initialAssessment/' + type, data);
  }
  /*----------------------------------follow-up-----------------------------*/

  getFollowuphistory(IndividualId, screeningId, diseaseId) {
    return this.http.get(
      '/cphm/condition/' +
        diseaseId +
        '/individual/' +
        IndividualId +
        '/program/1/examination/' +
        screeningId +
        '/followUp'
    );
  }
  /*-------------------------------screening-action-details--oral----------------------------*/

  getActionDetailsOral(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/100/individual/' + individualId + '/program/1/examination/' + screeningId + '/actionDetails'
    );
  }

  /*-------------------------------screening-action-details--breast----------------------------*/

  getActionDetailsBreast(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/200/individual/' + individualId + '/program/1/examination/' + screeningId + '/actionDetails'
    );
  }
  /*-------------------------------screening-action-details--cervical----------------------------*/

  getActionDetailsCervical(individualId, screeningId) {
    return this.http.get(
      `/cphm/condition/300/individual/${individualId}/program/1/examination/${screeningId}/actionDetails`
    );
  }

  saveDiseaseFollowup(data, screeningId, IndividualId, diseaseId) {
    return this.http.post(
      '/cphm/condition/' +
        diseaseId +
        '/individual/' +
        IndividualId +
        '/program/1/examination/' +
        screeningId +
        '/followUp',
      data
    );
  }
  saveDiseaseFollowup1(data, screeningId, IndividualId, diseaseId, facilityId) {
    return this.http.post(
      '/cphm/condition/' +
        diseaseId +
        '/individual/' +
        IndividualId +
        '/examination/' +
        screeningId +
        '/facility/' +
        facilityId +
        '/followUp',
      data
    );
  }
  getDiseaseFollowup1(screeningId, IndividualId, diseaseId, facilityId) {
    return this.http.get(
      '/cphm/condition/' +
        diseaseId +
        '/individual/' +
        IndividualId +
        '/examination/' +
        screeningId +
        '/facility/' +
        facilityId +
        '/followUp'
    );
  }
  /*-----------------------------------ORAL-----------------------------------*/
  getOralCancerExamination(individualId, screeningId) {
    return this.http.get('/cphm/condition/100/individual/' + individualId + '/program/1/examination/' + screeningId);
  }
  saveOralCancerExamination(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/100/individual/' + individualId + '/program/1/examination/' + screeningId,
      data
    );
  }

  getOralCancerDiagnosis(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/100/individual/' + individualId + '/program/1/examination/' + screeningId + '/diagnosis'
    );
  }

  saveOralCancerDiagnosis(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/100/individual/' + individualId + '/program/1/examination/' + screeningId + '/diagnosis',
      data
    );
  }

  getOralCancerTreatment(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/100/individual/' + individualId + '/program/1/examination/' + screeningId + '/treatment'
    );
  }
  saveOralCancerTreatment(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/100/individual/' + individualId + '/program/1/examination/' + screeningId + '/treatment',
      data
    );
  }

  saveOralCancerReferral(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/100/individual/' + individualId + '/program/1/examination/' + screeningId + '/refer',
      data
    );
  }

  getBreastCancerExamination(individualId, screeningId) {
    return this.http.get('/cphm/condition/200/individual/' + individualId + '/program/1/examination/' + screeningId);
  }
  saveBreastCancerExamination(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/200/individual/' + individualId + '/program/1/examination/' + screeningId,
      data
    );
  }
  getBreastCancerDiagnosis(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/200/individual/' + individualId + '/program/1/examination/' + screeningId + '/diagnosis'
    );
  }
  saveBreastCancerDiagnosis(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/200/individual/' + individualId + '/program/1/examination/' + screeningId + '/diagnosis',
      data
    );
  }
  getBreastCancerTreatment(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/200/individual/' + individualId + '/program/1/examination/' + screeningId + '/treatment'
    );
  }
  saveBreastCancerTreatment(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/200/individual/' + individualId + '/program/1/examination/' + screeningId + '/treatment',
      data
    );
  }
  saveBreastCancerReferral(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/200/individual/' + individualId + '/program/1/examination/' + screeningId + '/refer',
      data
    );
  }
  /*--------------------------cervical-------------------------------------------*/

  getCervicalCancerExamination(individualId, screeningId) {
    return this.http.get('/cphm/condition/300/individual/' + individualId + '/program/1/examination/' + screeningId);
  }
  saveCervicalCancerExamination(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/300/individual/' + individualId + '/program/1/examination/' + screeningId,
      data
    );
  }
  getCervicalCancerDiagnosis(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/300/individual/' + individualId + '/program/1/examination/' + screeningId + '/diagnosis'
    );
  }
  saveCervicalCancerDiagnosis(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/300/individual/' + individualId + '/program/1/examination/' + screeningId + '/diagnosis',
      data
    );
  }
  getCervicalCancerTreatment(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/300/individual/' + individualId + '/program/1/examination/' + screeningId + '/treatment'
    );
  }
  saveCervicalCancerTreatment(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/300/individual/' + individualId + '/program/1/examination/' + screeningId + '/treatment',
      data
    );
  }
  saveCervicalCancerReferral(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/300/individual/' + individualId + '/program/1/examination/' + screeningId + '/refer',
      data
    );
  }

  saveChangeSreeningStatus(data, screeningId, individualId, diseaseid) {
    return this.http.post(
      '/cphm/condition/' +
        diseaseid +
        '/individual/' +
        individualId +
        '/program/1/examination/' +
        screeningId +
        '/status',
      data
    );
  }

  saveAddTreatment(data, individualId, diseaseid) {
    return this.http.post('/cphm/condition/' + diseaseid + '/individual/' + individualId + '/teleconsult', data);
  }
  saveQuickEdt(data, individualId, diseaseid) {
    return this.http.post('/cphm/condition/' + diseaseid + '/individual/' + individualId + '/quickedt', data);
  }
  saveMedicine(data) {
    return this.http.post('/cphm/drug/management/medicine/stateMedicines', data);
  }
  getMedicine(diseaseid) {
    return this.http.get('/cphm/drug/management/medicine/stateMedicines/disease/'+diseaseid);
  }
  

  /*--------------------------Hypertension-------------------------------------------*/
  getActionDetails = function (screeningId, individualId, diseaseId) {
    return this.http.get(
      '/cphm/condition/' +
        diseaseId +
        '/individual/' +
        individualId +
        '/program/1/examination/' +
        screeningId +
        '/actionDetails'
    );
  };
  getHyper_ExamDetails(individualId, screeningId) {
    return this.http.get('/cphm/condition/500/individual/' + individualId + '/program/1/examination/' + screeningId);
  }
  saveHyper_ExamDetails(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/500/individual/' + individualId + '/program/1/examination/' + screeningId,
      data
    );
  }
  recommendedTreatmentDetails(individualId, screeningId, queryParams = '') {
    return this.http.get(
      '/cphm/condition/500/individual/' +
        individualId +
        '/program/1/examination/' +
        screeningId +
        '/recommendedTreatment' + queryParams
    );
  }
  saveHyperTreatDetails(data, individualId, screeningId, diseasenumber) {
    return this.http.post(
      '/cphm/condition/500/individual/' + individualId + '/program/1/examination/' + screeningId + '/treatment',
      data
    );
  }
  saveHyperDiagnosisDetails(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/500/individual/' + individualId + '/program/1/examination/' + screeningId + '/diagnosis',
      data
    );
  }

  getHyperHistoryList(individualId, screeningId) {
    return this.http.get(
      '/cphm/condition/500/individual/' + individualId + '/program/1/examination/' + screeningId + '/treatmentHistory'
    );
  }

  saveHyperExplicitRefer(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/500/individual/' + individualId + '/program/1/examination/' + screeningId + '/refer',
      data
    );
  }

  getHypertensionCDSSMedicineDetails() {
    return this.http.get('/src/app/assets/json/hypertensionMedicineCdss.json');
  }

  createPatientEnrollment(data) {
    return this.http.post(
      '/cphm/enrollment/individual' + (data.enrollmentFormId ? '?enrollmentFormId=' + data.enrollmentFormId : ''),
      data
    );
  }

  getMatchingTypeSubcentername(subcentername) {
    return this.http.get('/cphm/readOnly/admin/v1/admin/location/subcenters/' + subcentername);
  }

  getMatchingPhcForEnrollment(phc) {
    return this.http.get('/cphm/readOnly/admin/v1/admin/location/phcs/' + phc);
  }

  getMatchingSubcenterForEnrollment(phcId) {
    return this.http.get('/cphm/readOnly/admin/adminOperations/locationType/PHC/locationId/' + phcId + '/children');
  }
  getMatchingVillagesForEnrollment(subcenter) {
    return this.http.get('/cphm/readOnly/admin/v1/admin/location/subcenter/' + subcenter + '/villages');
  }
  getMatchingASHAForEnrollment(subcenterid, villageid) {
    return this.http.get(
      '/cphm/readOnly/admin/v1/admin/location/subcenter/' + subcenterid + '/village/' + villageid + '/ashas'
    );
  }
  getDistricts(stateId) {
    return this.http.get('/cphm/readOnly/admin/adminOperations/locationType/STATE/locationId/' + stateId + '/children');
  }
  getTalukas(districtId) {
    return this.http.get(
      '/cphm/readOnly/admin/adminOperations/locationType/DISTRICT/locationId/' + districtId + '/children'
    );
  }
  getPhcs(talukaId) {
    return this.http.get(
      '/cphm/readOnly/admin/adminOperations/locationType/TALUKA/locationId/' + talukaId + '/children'
    );
  }
  saveCbackDetails(data, individualId) {
    return this.http.post('/cphm/php/individual/' + individualId + '/cbacDetails', data);
  }

  saveNewMember(data, familyId) {
    return this.http.put(
      '/cphm/enrollment/family/' +
        familyId +
        '/individual' +
        (data.enrollmentFormId ? '?enrollmentFormId=' + data.enrollmentFormId : ''),
      data
    );
  }

  saveCovidAssessmentDetails(data, individualId) {
    return this.http.post('/cphm/php/individual/' + individualId + '/covid/riskAssessment/saveData', data);
  }

  updateEnrollment(data, individualId) {
    return this.http.put('/cphm/enrollment/individual/' + individualId, data);
  }

  requestDataFromMultipleSources(individualId): Observable<any[]> {
    const response1 = this.getfamilyEnrollmentDetails(individualId),
      response2 = this.getEnrollmentDetails(individualId),
      response3 = this.getCbacDetails(individualId);
    // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
    return forkJoin([response1, response2, response3]);
  }
  getfamilyEnrollmentDetails(individualId) {
    return this.http.get('/cphm/php/individual/' + individualId + '/familyDetails');
  }

  getCovidAssessmentDetails(individualId) {
    return this.http.get('/cphm/php/individual/' + individualId + '/covid/riskAssessment/getData');
  }
  getEnrollmentDetails(individualId) {
    return this.http.get('/cphm/enrollment/individual/' + individualId);
  }
  getCbacDetails(individualId) {
    return this.http.get('/cphm/php/individual/' + individualId + '/cbacDetails');
  }

  /*---------------print-related-services----------------------*/
  getPrint_DSR(individualId) {
    return this.http.get('/cphm/php/individual/' + individualId + '/getCdssSuggestionForPrint');
  }
  getPrint_prescription(individualId) {
    return this.http.get('/cphm/php/individual/' + individualId + '/getDataForPrintPrescription');
  }

  postdiseaseinfo(individualId, diseaseid) {
    return this.http.post(
      '/cphm/condition/' + diseaseid + '/individual/' + individualId + '/program/1/addExamination',
      null
    );
  }

  /*--------------------diabetes start--------------*/

  saveDiabetesExplicitRefer(individualID, examinationID, facilityID, data) {
    return this.http.post(
      '/cphm/condition/600/individual/' +
        individualID +
        '/examination/' +
        examinationID +
        '/facility/' +
        facilityID +
        '/refer',
      data
    );
  }
  getDiabetesCDSSMedicineDetails() {
    return this.http.get('/src/app/assets/json/diabetesMedicineCdss.json');
  }

  getDiabHistoryList(individualId, screeningId, facilityId) {
    return this.http.get(
      '/cphm/condition/600/individual/' +
        individualId +
        '/examination/' +
        screeningId +
        '/facility/' +
        facilityId +
        '/treatmentHistory'
    );
  }

  getDiabetesActionDetails(individualID, examinationID, facilityID) {
    return this.http.get(
      '/cphm/condition/600/individual/' +
        individualID +
        '/examination/' +
        examinationID +
        '/facility/' +
        facilityID +
        '/actionDetails'
    );
  }
  /********* Populate Diabetes Exam  */

  getDiabetesExamNew(individualID, examinationID, facilityID) {
    return this.http.get(
      '/cphm/condition/600/individual/' +
        individualID +
        '/examination/' +
        examinationID +
        '/facility/' +
        facilityID +
        '/populateDiabetesExamination'
    );
  }
  saveDiabetesExamination(individualID, examinationID, facilityID, data) {
    return this.http.post(
      '/cphm/condition/600/individual/' + individualID + '/examination/' + examinationID + '/facility/' + facilityID,
      data
    );
  }
  getDiabetesRecommendedTreatment(individualID, examinationID, facilityID, queryParams = '') {
    return this.http.get(
      '/cphm/condition/600/individual/' +
        individualID +
        '/examination/' +
        examinationID +
        '/facility/' +
        facilityID +
        '/recommendedTreatment'+queryParams
    );
  }
  saveDiabetesTreatment(individualID, examinationID, facilityID, data) {
    return this.http.post(
      '/cphm/condition/600/individual/' +
        individualID +
        '/examination//' +
        examinationID +
        '/facility/' +
        facilityID +
        '/treatment',
      data
    );
  }
  saveDiabetesDiagnosis(individualID, examinationID, facilityID, data) {
    return this.http.post(
      '/cphm/condition/600/individual/' +
        individualID +
        '/examination/' +
        examinationID +
        '/facility/' +
        facilityID +
        '/diagnosis',
      data
    );
  }

  /*-------------------------drug-services--------------------------------------------*/
  getMedicineList() {
    return this.http.get('/cphm/drug/inventory/allPhcDrugs');
  }
  getReport(facility) {
    return this.http.get('/cphm/drug/inventory/getDrugStockDetails/' + facility);
  }
  addReceivedIssued_Drug(data) {
    return this.http.post('/cphm/drug/inventory/saveDrugAndQuantityDetails', data);
  }
  addnewDrug(data) {
    return this.http.post('/cphm/drug/inventory/addMedicine', data);
  }

  /*-------------------------drug-services--------------------------------------------*/

  getGeneralExamHistoryDetails(screeningId, individualId) {
    return this.http.get('/cphm/condition/900/individual/' + individualId + '/program/1/examination/' + screeningId);
  }

  getgeneralsymptomsList(individualId, data) {
    return this.http.get('/cphm/v2/search/symptom/' + data + '/search');
  }

  saveGeneralExam(data, individualId, screeningId) {
    return this.http.post(
      '/cphm/condition/900/individual/' + individualId + '/program/1/examination/' + screeningId,
      data
    );
  }

  /*******************incentive******************************************/

  getIncentiveInformation(subcenterID, yearmonth) {
    return this.http.get(
      '/cphm/ms1/incentive/subcenterid/' + subcenterID + '/filteryearmonth/' + yearmonth + '/viewincentives'
    );
  }

  updateIncentiveInformation(data) {
    return this.http.post('/cphm/ms1/incentive/saveincentivesstatus', data);
  }

  requestScreeningHistoryDataFromMultipleSources(patient): Observable<any[]> {
    const response1 = this.getScreeningPersonalHistory(patient.individualId);
    let response2;
    if (patient.gender === 'M' || patient.gender === 'Male') {
      return forkJoin([response1]);
    } else {
      // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
      response2 = this.getScreeningMenstruallHistory(patient.individualId);
      return forkJoin([response1, response2]);
    }
  }

  saveScreeningHistoryDataFromMultipleSources(patient, data): Observable<any[]> {
    const response1 = this.saveScreeningPersonalHistory(patient.individualId, data.anmPersonalHistory);
    let response2;
    if (patient.gender === 'M' || patient.gender === 'Male') {
      return forkJoin([response1]);
    } else {
      // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
      response2 = this.saveScreeningMenstruallHistory(patient.individualId, data.anmMenstrualHistory);
      return forkJoin([response1, response2]);
    }
  }

  getScreeningPersonalHistory(individualId) {
    return this.http.get('/cphm/php/screeningdetails/individual/' + individualId + '/anmPersonalHistory');
  }

  saveScreeningPersonalHistory(individualId, data) {
    return this.http.post('/cphm/php/screeningdetails/individual/' + individualId + '/anmPersonalHistory', data);
  }

  getScreeningMenstruallHistory(individualId) {
    return this.http.get('/cphm/php/screeningdetails/individual/' + individualId + '/anmMenstrualHistory');
  }

  saveScreeningMenstruallHistory(individualId, data) {
    return this.http.post('/cphm/php/screeningdetails/individual/' + individualId + '/anmMenstrualHistory', data);
  }

  getScreeningPersonalExamination(individualId) {
    return this.http.get('/cphm/php/screeningdetails/individual/' + individualId + '/anmPersonalExam ');
  }

  saveScreeningPersonalExamination(individualId, data) {
    return this.http.post('/cphm/php/screeningdetails/individual/' + individualId + '/anmPersonalExam', data);
  }

  getScreeningDetails(screeningId, diseaseId, individualId) {
    return this.http.get('/cphm/condition/' + diseaseId + '/individual/' + individualId + '/screening/' + screeningId);
  }

  requestScreeningDataFromMultipleSources(screeningId, diseaseId, individualId, facilityId?): Observable<any[]> {
    if (screeningId) {
      const response1 = this.getScreeningDetails(screeningId, diseaseId, individualId);
      let response2;
      switch (diseaseId) {
        case '500':
          response2 = this.getActionDetails(screeningId, individualId, diseaseId);
          break;
        case '600':
          response2 = this.getDiabetesActionDetails(individualId, screeningId, facilityId);
          break;
        case '100':
          response2 = this.getActionDetails(screeningId, individualId, 100);
          break;
        case '200':
          response2 = this.getActionDetails(screeningId, individualId, 200);
          break;
        case '300':
          response2 = this.getActionDetails(screeningId, individualId, 300);
          break;
        default:
          break;
      }
      // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
      return forkJoin([response1, response2]);
    } else {
      return forkJoin([of({})]);
    }
  }

  saveScreeningDetails(diseaseId, individualId, data) {
    return this.http.post('/cphm/condition/' + diseaseId + '/individual/' + individualId + '/screening', data);
  }

  getANMUserDetails(subcenterId) {
    return this.http.get<any[]>(
      '/cphm/readOnly/admin/adminOperations/locationType/SUBCENTER/locationId/' + subcenterId + '/users'
    );
  }
  getParentHierarchyData(fecilityType, fecilityId) {
    return this.http.get<any[]>(
      `/cphm/readOnly/admin/v1/admin/facility/facilityType/${fecilityType}/facilityId/${fecilityId}`
    );
  }

  uploadTeleconfFile(individualId, data) {
    return this.http.post(`/cphm/php/screeningdetails/individual/${individualId}/teleconsult/attachFile`, data);
  }

  removeTeleconFile(individualId, upload) {
    return this.http.post(`cphm/php/screeningdetails/individual/${individualId}/teleconsult/deleteFile`, upload);
  }

  deletePatient(individualId) {
    return this.http.put('/cphm/softDelete/enrollment/individual/' + individualId, {});
  }
  getNinFacilityProfileData() {
    return this.http.get(`/cphm/readOnly/admin/v1/admin/facility/profile`);
  }
  facilityPendingTask() {
    return this.http.get(`/cphm/readOnly/admin/v1/admin/facility/pendingTasks`);

  }
  ninNumberVerify(ninNumber,facilityTypeId,facilityId) {
    const headers = {
      headers: new HttpHeaders()
        .set('skipRetry', 'true')
    }
    return this.http.get(`/cphm/admin/nin/${ninNumber}/getNinAvailability?facilityType=${facilityTypeId}&facilityId=${facilityId}`, headers);
  }
  mapNinNumber(facilityTypeId,facilityId, payload) {
    return this.http.post(`/cphm/admin/nin/facilityType/${facilityTypeId}/facilityId/${facilityId}/mapNIN`, payload);
  }
  lgdCodeUpdate(facilityType, facilityId, payload) {
    return this.http.put(`/cphm/commonAdminOperations/facility/updateProfile`, payload);
  }
  validateLgdCode(facilityType, facilityId, payload) {
    return firstValueFrom(this.http.post(`/cphm/commonAdminOperations/location/locationType/${facilityType}/locationId/${facilityId}/validateLgdCodeMappingRequest`,payload));
  }
  getLgdCodeOptions(id, value) {
    return this.http.get(`/cphm/commonAdminOperations/location/locationType/DISTRICT/locationLgdCode/${id}/getAllLgdVillages?blockLgdCode=${value}`);
  }
  getLgdCodeTaluka(value) {
    return this.http.get(`/cphm/commonAdminOperations/location/locationType/DISTRICT/locationLgdCode/${value}/getAllLgdSubDistricts`);
  }
  getLgdCodeBlocks(value) {
    return this.http.get(`/cphm/commonAdminOperations/location/locationType/DISTRICT/locationLgdCode/${value}/getAllLgdBlocks`);
  }
}
